import { ReactComponent as SvgArrowRight } from '@img/icons/arrow-right.svg';
import * as React from 'react';
import { useLockBodyScroll } from 'react-use';
import LinkButton from '../Buttons/LinkButton/LinkButton';
import S from './NavigationMobile.styles';
const NavigationMobile = ({ cta, items, themeOption = 'light', visible, }) => {
    useLockBodyScroll(visible);
    return (React.createElement(S.Navigation, { "aria-hidden": !visible, themeOption: themeOption, initial: "hidden", animate: visible ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                transitionEnd: {
                    display: 'none',
                },
            },
            visible: {
                display: 'block',
                opacity: 1,
            },
        }, transition: {
            duration: 0.3,
            ease: 'easeOut',
            type: 'tween',
        } },
        React.createElement(S.NavigationList, null,
            items.map((item) => {
                return (React.createElement(S.NavigationItem, { key: item.id },
                    React.createElement(S.NavigationLink, { href: item.url, tabIndex: visible ? 0 : -1, target: item.target, "aria-label": item.accessibleText }, item.text)));
            }),
            cta?.text && (React.createElement(S.CtaWrapper, null,
                React.createElement(LinkButton, { themeOption: themeOption === 'light' ? 'brown' : 'white', href: cta.url, icon: SvgArrowRight, target: cta.target, title: cta.text, "aria-label": cta.accessibleText }))))));
};
export default NavigationMobile;
